import gql from 'graphql-tag'

export const CONTACTS_EXPORT_QUERY = gql`
    query contactsExport {
        contactsExport {
            status
        }
    }
`
